/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./LightGrayInformationBlock.vue?vue&type=template&id=b5731274"
import script from "./LightGrayInformationBlock.vue?vue&type=script&lang=js"
export * from "./LightGrayInformationBlock.vue?vue&type=script&lang=js"
import style0 from "./LightGrayInformationBlock.vue?vue&type=style&index=0&id=b5731274&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports